// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TitlePostBlockSlice_wrapper__zwnx0"};